import { lazy } from 'react';

export const LazyIntegrationEditTemplatePage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--integration-edit-template-page" */ './integration-edit-template-page'
    ),
);
